import { MenuItem } from "@mui/material";

export const generateTimeOptions = (from: number, to: number) => {
    const options = [];

    for (let hour = from; hour <= to; hour++) {
      for (let minute = 0; minute < 60; minute += 30) {
        const time = `${hour.toString().padStart(2, "0")}:${minute
          .toString()
          .padStart(2, "0")}`;
        options.push(
          <MenuItem key={time} value={time}>
            {time}
          </MenuItem>
        );
      }
    }
    return options;
  };